class BESSAppProjectMandatoryCreditsSummary extends BESSAppBase {

    constructor() {
        super();
        this.node = $('.app-mandatory-credits-summary');
        if (this.node.length === 0) {
            this.node = null;
            return;
        }
        this.inner = this.node.find('.inner');
        this.nPassed = this.node.find('.n_passed');
        this.nCredits = this.node.find('.n_credits');
        this.mandatoryCreditItems = this.node.find('.app-mandatory-credits-list');
    }

    update(mandatoryCreditSummary) {
        if (this.node == null) {
            return;
        }
        this.inner.addClassIf('app-mandatory-credits-passed', mandatoryCreditSummary['all_passed']);
        this.inner.addClassIf('app-mandatory-credits-warn', !mandatoryCreditSummary['all_passed']);
        this.nPassed.text(mandatoryCreditSummary['n_mandatory_credits_passed']);
        this.nCredits.text(mandatoryCreditSummary['n_mandatory_credits']);

        this.forEach(mandatoryCreditSummary['mandatory_credits'], this.updateCredit);

        $('.project-inner').addClassIf('app-mandatory-credits-shown', mandatoryCreditSummary['mandatory_credits_shown']);
    }

    updateCredit(mandatoryCredit) {
        let node = this.mandatoryCreditItems.find('li[data-credit="' + mandatoryCredit.code + '"]');
        node.find('.mc_icon_passed').addClassIf('show', mandatoryCredit.passed);
        node.find('.mc_icon_not_passed').addClassIf('show', !mandatoryCredit.passed);
    }
}